import { ArrowRight } from "lucide-react";

/**
 * CTA réutilisable "Besoin d'un déménageur ?" — partenariat Big Déménagement.
 * Optimisé mobile : titre sur une ligne, padding compact.
 */
const BigDemenageurCTA = ({ testId = "bigdem-cta" }) => (
  <div className="relative overflow-hidden rounded-3xl bg-[#237cb5] text-white p-5 sm:p-8 lg:p-12 shadow-[0_40px_80px_-40px_rgba(35,124,181,0.55)]">
    <div className="absolute -top-24 -right-16 h-72 w-72 rounded-full blur-3xl opacity-30 bg-[#5793d8]" aria-hidden="true" />
    <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6 items-center">
      <div className="lg:col-span-8">
        <h2 className="text-[26px] sm:text-[30px] md:text-[36px] font-extrabold leading-tight text-white">
          Besoin d'un déménageur&nbsp;?
        </h2>
        <p className="mt-3 lg:mt-4 text-white/90 text-[14px] sm:text-[15px] lg:text-base leading-[1.55] lg:leading-[1.8] max-w-2xl">
          Vous déménagez à Paris ou en Île-de-France&nbsp;? Avec{" "}
          <strong className="font-bold text-white">Big Déménagement</strong>, les cartons et le matériel
          d'emballage peuvent être fournis{" "}
          <strong className="font-bold text-white">gratuitement</strong> selon la formule choisie.
        </p>
        <p className="mt-2 lg:mt-3 text-white/85 text-[14px] sm:text-[15px] lg:text-base leading-[1.55] lg:leading-[1.8] max-w-2xl">
          Gagnez du temps et confiez votre déménagement à des professionnels.
        </p>
      </div>
      <div className="lg:col-span-4 flex lg:justify-end">
        <a
          href="https://bigdemenagement.fr/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 h-11 lg:h-12 rounded-xl px-5 lg:px-6 bg-[#FF7A00] hover:bg-[#E66E00] text-white text-[13.5px] lg:text-[14px] font-semibold transition-colors shadow-[0_18px_30px_-12px_rgba(255,122,0,0.55)] whitespace-nowrap"
          data-testid={testId}
        >
          Devis gratuit
          <ArrowRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  </div>
);

export default BigDemenageurCTA;
